var exports = {
  "zr": "MacPermissionsSettingsRow.module__root___dzZ0Rk",
  "h_": "MacPermissionsSettingsRow.module__description___dzZ0Rk",
  "Mn": "MacPermissionsSettingsRow.module__lines___dzZ0Rk",
  "n8": "MacPermissionsSettingsRow.module__line___dzZ0Rk",
  "Om": "MacPermissionsSettingsRow.module__dot___dzZ0Rk",
  "Yf": "MacPermissionsSettingsRow.module__dotAllowed___dzZ0Rk",
  "H0": "MacPermissionsSettingsRow.module__dotDenied___dzZ0Rk",
  "Pf": "MacPermissionsSettingsRow.module__label___dzZ0Rk",
  "ZY": "MacPermissionsSettingsRow.module__trailing___dzZ0Rk",
  "XI": "MacPermissionsSettingsRow.module__action___dzZ0Rk",
  "TQ": "MacPermissionsSettingsRow.module__allowed___dzZ0Rk",
  "IR": "MacPermissionsSettingsRow.module__screenReaderOnly___dzZ0Rk",
  "v9": "MacPermissionsSettingsRow.module__advice___dzZ0Rk",
};

module.exports = exports;
